<btw-academy-header/>
<div class="app-container about-values pt-4 pb-5">
  <h2>BMW TechWorks Academy</h2>
  <p class="mt-4 about-text">
    Este platforma educațională și de dezvoltare a BMW TechWorks România, creată pentru a construi o punte solidă între
    mediul academic și industria tehnologică globală.
    Academia își propune să formeze o nouă generație de specialiști în IT, software engineering și automotive
    technology, oferind tinerilor acces la resurse, mentori și experiențe de învățare autentice, într-un cadru
    colaborativ și inovator.
  </p>

  <p class="about-text">
    Prin programele sale de mentorat, internship și formare continuă, BMW TechWorks România Academy sprijină tranziția
    naturală a studenților și tinerilor profesioniști către cariere în domenii de vârf.
    Activitățile includ programe aplicate, ateliere tematice, proiecte interdisciplinare, evenimente de inovație și
    colaborări cu universități din România și din străinătate.
  </p>

  <p class="about-text">
    Misiunea Academiei este de a dezvolta competențe relevante pentru viitor, de a promova cultura tehnologică și de a
    crea un ecosistem educațional în care ideile, cercetarea și inovația se întâlnesc.
    BMW TechWorks România Academy este, astfel, un spațiu unde pasiunea pentru tehnologie se transformă în performanță
    profesională și leadership responsabil.
  </p>
</div>

<div class="app-container our-values pb-5 pt-5">
  <div class="btw-academy-cards">
    @for (item of infoCards; track item.title) {
      <box-item-flip
        [content]="item.content"
        [description]="item.description"
        [imgClass]="item.imgClass"
        [title]="item.title"
        [url]="item.url">
      </box-item-flip>
    }
  </div>
</div>
